import { ILoadReportDataParams } from '../markout.action';

// True when the data request narrows the result: any level/grid filter, or a
// Current Day Trade Side / Min Notional value (the subscriber omits their
// defaults). Sort and paging do not count.
export const isFilteredDataRequest = (params: ILoadReportDataParams): boolean => Boolean(
  params.riskLevel?.length
  || params.servers?.length
  || params.accountGroups?.length
  || params.accounts?.length
  || params.symbols?.length
  || params.side !== undefined
  || params.minNotional !== undefined,
);
